module.exports = __webpack_public_path__ + "img/cover-roger.cbb8cc03.png";